import { FAQType } from './FAQPageSchema';

export const generateFAQPageSchema = (faqs: FAQType[]) => {
  return {
    '@context': 'https://schema.org',
    type: 'FAQPage',
    mainEntity: faqs.map(({ question, answer }) => {
      return {
        '@type': 'Question',
        name: question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: answer,
        },
      };
    }),
  };
};
